/* eslint-disable */
// src/services/rentService.js

import axios from "services/axiosConfig";

const API_URL = "/api/rent";

// helper para normalizar la forma del rent que vuelve del backend
function normalizeRent(r) { 
  if (!r) return null;
  return {
    Id: r.Id,
    Price: r.Price,
    PaymentFrequency: r.PaymentFrequency,
    IsActive: typeof r.IsActive === "boolean" ? r.IsActive : true,
  };
} 

class RentService {
  // Crear rent con isActive true
  static async createRent(rent) {
    try {
      const payload = {
        Price: rent.Price,
        PaymentFrequency: rent.PaymentFrequency,
      };
      const response = await axios.post(API_URL, payload);
      const data = response.data?.rent ?? response.data;
      return normalizeRent(data);
    } catch (error) {
      console.error("Error al crear el alquiler:", error);
      return null;
    }
  }

  // Obtener todos los rents
  static async getAllRents() {
    try {
      const response = await axios.get(API_URL);
      const list = Array.isArray(response.data) ? response.data : [];
      return list.map(normalizeRent);
    } catch (error) {
      console.error("Error al obtener los alquileres:", error);
      return [];
    }
  }

  // Obtener un rent por ID
  static async getRentById(id) {
    try {
      const endpoint = `${API_URL}/${id}`;
      const response = await axios.get(endpoint);
      return normalizeRent(response.data);
    } catch (error) {
      console.error("Error al obtener el alquiler por ID:", error);
      return null;
    }
  }

  // Actualizar un rent
  static async updateRent(id, rent) {
    try {
      const payload = {
        Price: rent.Price,
        PaymentFrequency: rent.PaymentFrequency,
      };
      const response = await axios.put(`${API_URL}/${id}`, payload);
      return response.status === 204;
    } catch (error) {
      console.error("Error al editar el alquiler:", error);
      return false;
    }
  }

  // soft-delete. Eliminar un rent por ID
  // IsActive false
  static async deleteRent(id) {
    try {
      const response = await axios.delete(`${API_URL}/${id}`);
      return response.status === 204;
    } catch (error) {
      if (error?.response?.status === 409) {
      console.warn("No se puede desactivar Rent: está en uso (409).");
      return false;
    }
    console.error("Error al desactivar el alquiler:", error);
    return false;
    }
  }
}

export default RentService;
